import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import AppShell from "@/pages/AppShell";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Courses from "@/pages/Courses";
import Assignments from "@/pages/Assignments";
import CalendarPage from "@/pages/Calendar";
import Focus from "@/pages/Focus";
import Analytics from "@/pages/Analytics";
import Profile from "@/pages/Profile";
import Settings from "@/pages/Settings";

function Protected({ children }) {
    const { user, loading } = useAuth();
    const loc = useLocation();
    if (loading || user === null) return <SplashLoader />;
    if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
    return children;
}

function SplashLoader() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-background">
            <div className="mono-label animate-pulse-soft">Loading StudySphere…</div>
        </div>
    );
}

function RedirectHome() {
    const { user, loading } = useAuth();
    if (loading || user === null) return <SplashLoader />;
    return <Navigate to={user ? "/app" : "/login"} replace />;
}

export default function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<RedirectHome />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/app" element={<Protected><AppShell /></Protected>}>
                            <Route index element={<Dashboard />} />
                            <Route path="courses" element={<Courses />} />
                            <Route path="assignments" element={<Assignments />} />
                            <Route path="calendar" element={<CalendarPage />} />
                            <Route path="focus" element={<Focus />} />
                            <Route path="analytics" element={<Analytics />} />
                            <Route path="profile" element={<Profile />} />
                            <Route path="settings" element={<Settings />} />
                        </Route>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                    <Toaster richColors closeButton />
                </BrowserRouter>
            </AuthProvider>
        </ThemeProvider>
    );
}
